export default __webpack_public_path__ + "static/media/sky.dd45ad87.jpg";